import { gql } from '@apollo/client';

export default class SettingsMutation {
    static CREATE_PURCHASED_FROM = gql`
        mutation createPurchasedFrom($name: String!) {
            createPurchasedFrom(name: $name)
        }
    `;

    static CREATE_PURCHASING_AGENT = gql`
        mutation createPurchasingAgent($name: String!) {
            createPurchasingAgent(name: $name)
        }
    `;

    static EDIT_PURCHASING_AGENT = gql`
        mutation editPurchasingAgent($id: Int!, $name: String!) {
            editPurchasingAgent(id: $id, name: $name)
        }
    `;

    static EDIT_PURCHASING_FROM = gql`
        mutation editPurchasingFrom($id: Int!, $name: String!) {
            editPurchasingFrom(id: $id, name: $name)
        }
    `;

    static DELETE_PURCHASING_FROM = gql`
        mutation deletePurchasingFrom($id: Int!) {
            deletePurchasingFrom(id: $id)
        }
    `;

    static DELETE_PURCHASING_AGENT = gql`
        mutation deletePurchasingAgent($id: Int!) {
            deletePurchasingAgent(id: $id)
        }
    `;

    static SAVE_USER_PREFERENCES = gql`
        mutation saveUserPreferences($userSettingId: ID, $key: String!, $value: String!) {
            saveUserPreferences(userSettingId: $userSettingId, key: $key, value: $value)
        }
    `;
}
